import BigNumber from "bignumber.js";
import { fromWei, toWei } from "web3-utils";
import { CoinType } from "../../conf/Config";
import DataCenter, { Calculator, QuoteCoinID } from "../DataCenter";
import { WalletInfo, WalletService } from "../WalletService";
import { WalletProvicer } from "./WalletProvider";
import Wallet, { hdkey } from "ethereumjs-wallet"
import * as util from 'ethereumjs-util'
import { Events, JSEvent } from "../../utils/JSEvent";
import Web3 from 'web3';
import * as bip39 from "bip39"

export class ETHWalletProvider extends WalletProvicer {
    #ECR20Abi = [{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "spender", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getCoinPoolAddress", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_coinPool", "type": "address" }], "name": "setCoinPoolAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "sender", "type": "address" }, { "name": "recipient", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "spender", "type": "address" }, { "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "withdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "amount", "type": "uint256" }, { "name": "serviceCharge", "type": "uint256" }, { "name": "orderId", "type": "string" }], "name": "requestWithdraw", "outputs": [], "payable": true, "stateMutability": "payable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "spender", "type": "address" }, { "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "recipient", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "myBalance", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "owner", "type": "address" }, { "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "inputs": [{ "name": "initinalSupply", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "payable": true, "stateMutability": "payable", "type": "fallback" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "orderId", "type": "string" }, { "indexed": true, "name": "serviceCharge", "type": "uint256" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "RequestWithdraw", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "to", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "owner", "type": "address" }, { "indexed": true, "name": "spender", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }];
    #contracts = {};
    #web3 = null;

    constructor(blockchain) {
        super(blockchain);
        this.#web3 = new Web3(new Web3.providers.WebsocketProvider(blockchain.url));
        this.subscribes = [];
    }

    getWeb3() {
        return this.#web3;
    }
    
    /**
     * @param {Token} token 
     * @param {String} address 
     * @returns {Promise<BigNumber>}
     */
    balanceOf(token, address) {
        return new Promise((resolve, reject) => {
            if (this.#web3 == null) {
                reject(this.makeError("web3 is null"))
            } else {
                if (token.name == "ETH") {
                    this.#ethBalance(address, r => {
                        const v = Calculator.toNumber(r, token.id)
                        resolve(v);
                    }, err => {
                        reject(err);
                    })
                } else {
                    this.#tokenBalance(address, token, r => {
                        const v = Calculator.toNumber(r, token.id)
                        resolve(v);
                    }, err => {
                        reject(err);
                    })
                }
            }
        })
    }

    subscribe() {
        if (this.subscribes.length > 0) {
            this.#web3.eth.clearSubscriptions();
        }
        this.subscribes = [];

        const walletInfo = WalletService.walletInfo;
        // const web3 = WalletService.web3;

        //const topic = this.#web3.eth.abi.encodeEventSignature('Transfer(address from, address to, uint256 value)');
        const topic = this.#web3.eth.abi.encodeEventSignature({
            name: 'Transfer',
            type: 'event',
            inputs: [{
                type: 'address',
                name: 'from'
            }, {
                type: 'address',
                name: 'to'
            }, {
                type: 'uint256',
                name: 'value'
            }]
        });

        DataCenter.getCoins().forEach(token => {
            switch (token.id) {
                case CoinType.ETH:
                    const sub = this.#web3.eth.subscribe(
                        'pendingTransactions', (error, result) => {
                            if (error != null) {
                                console.log(error)
                            }
                        }
                    ).on('data', t => {
                        this.#web3.eth.getTransaction(t).then(t => {
                            const from = util.Address.fromString(t.from);
                            const to = util.Address.fromString(t.to);
                            const w = util.Address.fromString(walletInfo.address);

                            if (from.equals(w) || to.equals(w)) {
                                JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: t });
                            }
                        })
                    })
                    this.subscribes.push(sub)
                    break;
                default:
                    const tsub = this.#web3.eth.subscribe("logs", {
                        address: token.address,
                        topics: [topic]
                    }, (error, result) => {
                        if (error != null) {
                            console.log(error)
                        }
                    }).on('data', (log) => {
                        const hf = util.addHexPrefix(new BigNumber(log.topics[1]).toString(16));
                        const ht = util.addHexPrefix(new BigNumber(log.topics[2]).toString(16));
                        const from = util.Address.fromString(hf);
                        const to = util.Address.fromString(ht);
                        const w = util.Address.fromString(walletInfo.address);
                        if (from.equals(w) || to.equals(w)) {
                            const tx = log.transactionHash;
                            this.#web3.eth.getTransaction(tx).then(t => {
                                JSEvent.emit(Events.Wallet.Transaction, { token: token, trans: t });
                            })
                        }
                    }).on('connected', id => {
                    })
                    this.subscribes.push(tsub)
                    break;
            }
        })
    }

    /**
     * 获取指定ECR20代币的合约对象
     * @param {Token} token 
     */
    contract(token) {
        let contract = this.#contracts[token.name];
        if (contract == null) {
            contract = new this.#web3.eth.Contract(this.#ECR20Abi, token.address);
        }
        return contract;
    }

    get ECR20Abi() {
        return this.#ECR20Abi;
    }


    #ethBalance(address, resolve, reject) {
        this.#web3.eth.getBalance(address).then(ret => {
            resolve(ret);
        })
    }

    #tokenBalance(address, token, resolve, reject) {
        const contract = this.contract(token);
        contract.methods.balanceOf(address).call({}, (error, result) => {
            if (error != null) {
                reject(error);
            } else {
                resolve(result);
            }
        })
    }

    importMnemonic(mnemonic) {
        return new Promise((resolve, reject) => {
            bip39.mnemonicToSeed(mnemonic).then(v => {
                if (!bip39.validateMnemonic(mnemonic)) {
                    reject({ code: -1, msg: "mnemonic format error" })
                    return;
                }

                const hdWallet = hdkey.fromMasterSeed(v);
                const key = hdWallet.derivePath("m/44'/60'/0'/0/0");
                const privateKey = util.bufferToHex(key._hdkey.privateKey);
                const publicKey = util.bufferToHex(key._hdkey.publicKey);
                let address = util.pubToAddress(key._hdkey.publicKey, true)
                address = util.toChecksumAddress("0x" + address.toString('hex'));


                const wi = new WalletInfo();
                wi.mnemonic = mnemonic;
                wi.privateKey = privateKey;
                wi.publicKey = publicKey;
                wi.address = address;

                resolve(wi);
            });
        })
    }

    isValidAddress(address) {
        return util.isValidAddress(address);
    }

    calcGasFee(gasPrice, gasUsed, quoteCoin) {
        const p = gasPrice.times(gasUsed);
        const p1 = Calculator.toNumber(p, QuoteCoinID);
        const p2 = p1.toTrimed(2, quoteCoin.showDecimals);
        return { bn: p1, str: p2 }
    }
}